import React, {forwardRef, useCallback, useEffect, useImperativeHandle, useState} from 'react';
import DroppableList from '../DraggingWrappers/DroppableList';
import styles from "../Merging.module.css";
import Consequence from "../../Consequence/Consequence";
import PulsingDivWrapper from "../DraggingWrappers/PulsingDivWrapper";


const ConsequencesMergingDisplay = forwardRef (({ patternSelected, fromPattern, toPattern }, ref) => {
    const [fromList, setFromList] = useState([]);
    const [toList, setToList] = useState([]);
    const [draggingTo, setDraggingTo] = useState(false)
    const [draggingFrom, setDraggingFrom] = useState(false)

    const existsInToList = useCallback((item) => {
        return (
            Array.isArray(toList) &&
            item && item.consequence &&
            toList.some(f => +item.consequence.consequence_id === +f.consequence.consequence_id)
        );
    }, [toList]);

    const existsInFromList = useCallback((item) => {
        return (
            Array.isArray(fromList) &&
            item && item.consequence &&
            fromList.some(f => +item.consequence.consequence_id === +f.consequence.consequence_id)
        );
    }, [fromList]);

    useEffect(() => {
        if (fromPattern && fromPattern.consequences) {
            setFromList(fromPattern.consequences.map((consequence, index) => {
                const id = consequence.consequence_id + " patternId-" + fromPattern.pattern_id
                const isGrayedOut = existsInToList({ consequence: consequence });
                return {
                    id,
                    consequence,
                    content: <div className={isGrayedOut ? styles.GrayedOut : ''}><Consequence consequence={consequence} extraStyle={`${styles.FromColor} ${styles.FromTextColor}`}/></div>,
                    index,
                    disableDrag: isGrayedOut
                }
            }))
        }
    }, [fromPattern, patternSelected, existsInToList]);

    useEffect(() => {
        if (toPattern && toPattern.consequence) {
            setToList(toPattern.consequences.map((consequence, index) => {
                const id = consequence.consequence_id + " patternId-" + toPattern.pattern_id
                return {
                    id,
                    consequence,
                    content: <Consequence consequence={consequence}/>,
                    index,
                    disableDrag: true
                }
            }))
        }
    }, [toPattern, patternSelected]);

    const moveItemBetweenLists = (item, start, destination) => {
        if (start === destination) {
            return;
        }
        if (start === 'fromList' && destination === 'toList' && !existsInToList(item)) {
            let newItem = {...item}
            newItem.content = <Consequence consequence={item.consequence} extraStyle={`${styles.FromColor} ${styles.FromTextColor}`}/>
            setToList(prev => [newItem, ...prev]); // Add to target
        } else if (start === 'toList' && destination === 'fromList' && existsInFromList(item)) {
            setToList(prev => prev.filter(i => +i.consequence.consequence_id !== +item.consequence.consequence_id))
        }
    };

    useImperativeHandle(ref, () => ({
        getList: () => {
            return toList.map(item => item.consequence);  // Return the current state of toList
        }
    }));

    return (
        <div className={styles.Container}>
            {/*This style is kinda cursed but it will likely not be necessary once consequence uses pattern component*/}
            <div className={styles.SplitCols} style={{maxWidth: '50%', marginRight: '-2.5%', paddingRight: '10px'}}>
                <h3>Consequence:</h3>
                <PulsingDivWrapper active={draggingFrom}>
                    <DroppableList
                        list={toList}
                        setList={setToList}
                        itemType={'CONSEQUENCE'}
                        targetListName="toList"
                        moveItemBetweenLists={moveItemBetweenLists}
                        setDragging={setDraggingTo}
                    />
                </PulsingDivWrapper>
            </div>
            <div className={styles.Separator}></div>
            <div className={styles.SplitCols} style={{maxWidth: '50%', marginLeft: '-2.5%', paddingLeft: '10px'}}>
                <h3>Consequence:</h3>
                <PulsingDivWrapper active={draggingTo}>
                    <DroppableList
                        list={fromList}
                        setList={setFromList}
                        itemType={'CONSEQUENCE'}
                        targetListName="fromList"
                        moveItemBetweenLists={moveItemBetweenLists}
                        setDragging={setDraggingFrom}
                    />
                </PulsingDivWrapper>
            </div>
        </div>
    )
});

export default ConsequencesMergingDisplay;
